import { Trans } from '~/common/context';
import { Button, Icon, Row } from '@wyz/ui';

type Props = {
  onReset: () => void;
};
function ResetButton({ onReset }: Props) {
  return (
    <Row className='d-flex justify-content-end'>
      <div className='p-0 w-auto'>
        <Button id='submit' variant='primary' onClick={onReset}>
          <Icon icon='search' size='xs' className='me-2' />
          <Trans i18nKey='app.common.button.new_search' />
        </Button>
      </div>
    </Row>
  );
}

export default ResetButton;
